import { render, staticRenderFns } from "./InviteNew.vue?vue&type=template&id=160183b8"
import script from "./InviteNew.vue?vue&type=script&lang=js"
export * from "./InviteNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports